<h3 class="font-weight-light mb-4 mt-5">Entity Search</h3>
<div class="input-group input-group-rounded input-group-lg mb-3">
  <input
    class="form-control form-control-white"
    type="text"
    placeholder="Search"
    aria-label="Search"
    [(ngModel)]="searchQuery"
    (keydown.enter)="doSearch()" />
  <div class="input-group-append">
    <button nkButton size="lg" color="primary" (click)="doSearch()"><i class="fa fa-search"></i></button>
  </div>
</div>
<a [routerLink]="['/company/']" [queryParams]="{ 'ss.st': 'SEARCH:' + searchQuery }"
  >Search in Company Browser <i class="fa fa-search"></i>
</a>

<nk-card andClass="mt-4">
  <nk-card-content type="table">
    <table class="table table-hover">
      <tr>
        <th>Search Result</th>
        <th>Extra info</th>
        <th width="200px">Status</th>
      </tr>
      <ng-container *ngIf="loading">
        <td colspan="3">Loading ...</td>
      </ng-container>
      <ng-container *ngIf="!loading">
        <tr *ngIf="searchList.length === 0 && !firstSearch">
          <td colspan="3">No results</td>
        </tr>
        <tr *ngIf="firstSearch">
          <td colspan="3">Search for a person or company by name or organization number.</td>
        </tr>
        <ng-container *ngFor="let searchEntry of searchList">
          <tr *ngIf="searchEntry.person_uuid" class="clickable-row" (click)="redirectToPerson(searchEntry.person_uuid)">
            <td>
              <i class="small text-muted fa fa-user me-2"></i>
              <!--Include a href so users can copy the url-->
              <a class="colorize text color-black" [routerLink]="['/person', searchEntry.person_uuid]">
                <span
                  [innerHtml]="searchEntry.search_label | titleCase | highlightText: searchQuerySent : 'weight-black'"
                  >{{ searchEntry.search_label }}</span
                >
              </a>
              <span class="text-muted"> ({{ searchEntry.search_label_aux }})</span>
            </td>
            <td>{{ searchEntry.search_label_aux }}</td>
            <td></td>
          </tr>
          <tr
            *ngIf="searchEntry.company_uuid"
            class="clickable-row"
            (click)="redirectToCompany(searchEntry.company_uuid)">
            <td>
              <i class="small text-muted fa fa-building me-2" *ngIf="!searchEntry.confirmed_dead_company_flag"></i>
              <i class="small text-muted fa fa-ban me-2" *ngIf="searchEntry.confirmed_dead_company_flag"></i>
              <!--Include a href so users can copy the url-->
              <a class="colorize text color-black" [routerLink]="['/company', searchEntry.company_uuid]">
                <span [innerHtml]="searchEntry.search_label | highlightText: searchQuerySent : 'weight-black'">{{
                  searchEntry.search_label
                }}</span>
              </a>
              <span class="small" *ngIf="searchEntry.search_target_type === 'company_alias'">
                (Previous
                <span [innerHtml]="searchEntry.search_target | highlightText: searchQuerySent : 'weight-black'">{{
                  searchEntry.search_target
                }}</span>
                )
              </span>
              <!--<span class="text-muted">-->
              <!--{{searchEntry.search_label_aux}}-->
              <!--</span>-->
            </td>
            <td>
              <span
                *ngIf="searchEntry.company_uuid"
                [innerHtml]="searchEntry.search_label_aux | highlightText: searchQuerySent : 'weight-black'">
                {{ searchEntry.search_label_aux }}
              </span>
            </td>
            <td>
              <ng-container *ngIf="searchEntry.confirmed_dead_company_flag">Company no longer exist</ng-container>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </table>
  </nk-card-content>
</nk-card>
